import { useDispatch, useSelector } from 'react-redux';

import { OperatorField } from './OperatorField';
import { OperatorsActions } from '../../store/reducers/operators';
import Select from '../common/Select';
import RadioGroup from '../common/RadioGroup';
import Radio from '../common/Radio';
import { DISABLED, ENABLED } from '../../constants/permissions';
import {
  PAYMENT_TERMS_NET_120,
  PAYMENT_TERMS_NET_30,
  PAYMENT_TERMS_NET_45,
  PAYMENT_TERMS_NET_60,
  PAYMENT_TERMS_NET_90,
  PaymentTermsDisplayName,
} from '../../constants/operators';

const invoiceOptions = [
  { label: PaymentTermsDisplayName[PAYMENT_TERMS_NET_30], value: PAYMENT_TERMS_NET_30 },
  { label: PaymentTermsDisplayName[PAYMENT_TERMS_NET_45], value: PAYMENT_TERMS_NET_45 },
  { label: PaymentTermsDisplayName[PAYMENT_TERMS_NET_60], value: PAYMENT_TERMS_NET_60 },
  { label: PaymentTermsDisplayName[PAYMENT_TERMS_NET_90], value: PAYMENT_TERMS_NET_90 },
  { label: PaymentTermsDisplayName[PAYMENT_TERMS_NET_120], value: PAYMENT_TERMS_NET_120 },
];

export function OperatorInvoicePaymentTerms() {
  const dispatch = useDispatch();

  const {
    configuration: { invoice },
  } = useSelector((state) => state.operators);

  const setInvoice = (value) => {
    dispatch({ type: OperatorsActions.configuration, payload: { invoice: { ...invoice, ...value } } });
  };

  return (
    <OperatorField
      title="Billing Terms"
      description="If the operator requires an invoice, please enable this option and specify the billing terms agreed upon with the vendor."
    >
      <RadioGroup
        name="invoice-enabled"
        onChange={(value) => setInvoice({ enabled: value === ENABLED })}
        selectedvalue={invoice?.enabled ? ENABLED : DISABLED}
      >
        <Radio id="invoice_required" value={ENABLED} label="Enabled" />
        <Radio id="invoice_not_required" value={DISABLED} label="Disabled" />
      </RadioGroup>
      <Select
        name="invoice-value"
        value={(invoice?.value || '').toString()}
        onChange={(value) => setInvoice({ value })}
        options={invoiceOptions}
        disabled={!invoice?.enabled}
      />
    </OperatorField>
  );
}
